<template>
  <div class="select-location">
    <Modal v-if="open" ref="locationModal" class="mk-modal mk-modal-location without-close-btn" :class="{'lg': isCN}" @close="close">
      <slot>
        <!-- <div class="search-input">
          <i class="material-icons">search</i>
          <input type="text" placeholder="輸入場館名稱">
        </div> -->
        <div class="search-result">
          <ul>
            <li v-for="(venue, index) in venueList" :key="index">
              <a herf="#"
                 :class="{'disabled': Number(venue.event_count) === 0}"
                 @click="update(venue.name, venue.id)"
              >
                {{ venue.name }}
                <span v-if="Number(venue.event_count) > -1" class="num">
                  {{ venue.event_count }}
                </span>
              </a>
            </li>
          </ul>
        </div>
      </slot>
    </Modal>
  </div>
</template>

<script>
import Modal from '@/components/common/Modal'

export default {
  name: 'ConcertLocationModal',
  components: {
    Modal
  },
  props: {
    open: {
      type: Boolean,
      default: false
    },
    venueList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      isCN: this.$isCN
    }
  },
  computed: {},
  created() {},
  mounted() {
  },
  methods: {
    close() {
      this.$emit('close')
    },
    update(label, val) {
      this.$emit('update-val', 'venue', label, val)
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';

.mk-modal-location{
  .search-input{
    position: relative;
    border-bottom: 1px solid $grey-ec;
    input{
      width: 100%;
      height: 56px;
      font-size: 16px;
      font-weight: bold;
      line-height: 56px;
      color: $grey-9b;
      border: 0;
      padding-left: 52px;
      outline: none;
      &::placeholder{
        color: $grey-9b;
      }
    }
    i{
      position: absolute;
      font-size: 24px;
      width: 24px;
      height: 24px;
      color: $theme-red;
      top: 0;
      bottom: 0;
      left: 24px;
      margin: auto;
    }
  }
  .search-result{
    text-align: left;
    ul{
      list-style: none;
      padding: 0;
      margin: 0;
      padding: 12px 10px;
      li{
        a{
          display: inline-block;
          width: 100%;
          line-height: 32px;
          padding: 12px 26px;
          font-size: 20px;
          color: $grey-7d;
          cursor: pointer;
          .num{
            font-size: 16px;
            font-weight: bold;
            color: $grey-9b;
            margin-left: 8px;
          }
          &.disabled{
            pointer-events: none;
            color: $grey-9b;
            opacity: .8;
            .num{
              color: $grey-9b;
            }
          }
        }
      }
    }
  }
}

@media only screen and (max-width: 767.98px) {
  .mk-modal-location{
    .search-result{
      ul{
        padding: 12px 0;
        li{
          a{
            padding: 0 24px;
          }
        }
      }
    }
  }
}
</style>

<style lang="scss">
.modal-mask {
  &.mk-modal-location{
    .modal-container{
      width: 435px;
    }
    &.lg{
      .modal-container{
        width: 530px;
      }
    }
  }
}

@media only screen and (max-width: 767.98px) {
  .modal-mask {
    &.mk-modal-location{
      .modal-container{
        width: 100%;
      }
    }
  }
}
</style>
